// Barrel export for How To Screen Record main images
export { default as recording } from './recording.png';
